import { useMemo } from 'react';

import { ModuleEntityType } from '~/common/types';
import { DateRangeProvider } from '~/components/DateRangeProvider';
import { ModuleContextProvider, ModuleContextProviderValue } from '~/components/ModuleContextProvider';
import { ModulePage } from '~/components/ModulePage/ModulePage';
import { useModulePageConfig } from '~/components/ModulePageConfigProvider';
import { ModuleSlot } from '~/components/ModuleSlot/ModuleSlot';
import { ResponsibleUsersProvider } from '~/components/ResponsibleUsersProvider';
import { ModuleSlotId } from '~/modules';
import { useContractDetail, useTabId } from '~/modules/Module.hooks';
import { RouteId } from '~/routes';

import { ContractDetailHeader } from './ContractDetailHeader/ContractDetailHeader';

export const ContractDetail = () => {
  const { contractId } = useContractDetail();
  const { tabId } = useTabId();

  const { modules, tabs } = useModulePageConfig({ pageId: RouteId.contractDetail(), tabId });

  const contextValue = useMemo<ModuleContextProviderValue>(
    () => ({ entity: ModuleEntityType.CONTRACT, entityId: contractId }),
    [contractId],
  );

  return (
    <DateRangeProvider>
      <ResponsibleUsersProvider>
        <ModulePage
          header={<ContractDetailHeader id={contractId} tabs={tabs} />}
          modules={
            <ModuleContextProvider value={contextValue}>
              <ModuleSlot id={ModuleSlotId.MAIN} modules={modules} />
            </ModuleContextProvider>
          }
        />
      </ResponsibleUsersProvider>
    </DateRangeProvider>
  );
};
